import * as React from 'react';

function SvgCommunityLogoBlack(props) {
  return (
    <svg
      width={1500}
      height={1500}
      viewBox="0 0 396.875 396.875"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g strokeWidth={0.601} color="#000" fill="#6f6f6f">
        <path
          style={{
            InkscapeStroke: 'none',
          }}
          d="M246.46 73.048l-53.233 123.018 10.427 4.513L256.891 77.56z"
        />
        <path
          style={{
            InkscapeStroke: 'none',
          }}
          d="M193.227 196.066L139.991 319.08l10.43 4.513 53.233-123.015z"
        />
        <path
          style={{
            InkscapeStroke: 'none',
          }}
          d="M247.867 84.109c-53.197-22.992-115.22-6.299-149.64 40.275a46.744 46.744 0 0141.563-2.25c23.68 10.239 34.578 37.718 24.34 61.376-10.238 23.659-37.735 34.537-61.416 24.298a46.71 46.71 0 01-26.82-31.816c-10.387 56.964 19.914 113.577 73.104 136.583 52.95 22.74 114.584 6.231 149.026-39.918a46.745 46.745 0 01-40.949 1.893c-23.68-10.24-34.578-37.718-24.34-61.377 10.238-23.658 37.735-34.537 61.416-24.298a46.711 46.711 0 0126.821 31.706c6.477-35.688-3.012-71.227-24.087-98.444-12.543-16.198-29.19-29.448-49.018-38.028z"
        />
        <path
          style={{
            InkscapeStroke: 'none',
          }}
          d="M196.519 73.748c-37.96.588-74.71 18.505-98.398 50.558l.172.192a46.613 46.613 0 0141.446-2.242c23.615 10.21 34.478 37.61 24.268 61.203-10.21 23.593-37.626 34.437-61.241 24.227a46.575 46.575 0 01-26.742-31.726l-.26.01c-10.398 57.023 19.935 113.697 73.181 136.727 53.005 22.765 114.706 6.237 149.185-39.961l-.169-.195a46.614 46.614 0 01-40.834 1.888c-23.615-10.211-34.482-37.61-24.272-61.203 10.21-23.593 37.63-34.44 61.245-24.23a46.577 46.577 0 0126.745 31.615l.257-.006c10.342-56.987-19.981-113.597-73.182-136.617-16.64-7.193-34.147-10.507-51.401-10.24zm.003.266a124.245 124.245 0 0151.291 10.218c52.929 22.902 83.146 79.117 73.1 135.81-3.613-13.977-13.43-25.545-26.709-31.287-23.747-10.267-51.323.643-61.59 24.367-10.266 23.724.663 51.283 24.41 61.55 13.087 5.652 28.008 4.98 40.573-1.702-34.465 45.788-95.811 62.132-148.547 39.483-52.975-22.913-83.198-79.194-73.097-135.924 3.582 14.02 13.403 25.634 26.709 31.4 23.747 10.268 51.323-.642 61.59-24.366 10.266-23.724-.663-51.283-24.41-61.55-13.315-5.745-28.509-4.945-41.184 2.046 23.648-31.722 60.15-49.46 97.864-50.045z"
        />
      </g>
    </svg>
  );
}

export default SvgCommunityLogoBlack;
